// // // utils/tenantMediaUtils.js
// // import { GetMediaURL, GetUploadMediaBaseLocation } from "../Utility/APICall";
// // import { paths } from "../Utility/Constants";

// // /**
// //  * Get display URL for tenant media using your GetMediaURL function
// //  * @param {Object} mediaItem - Media item with location
// //  * @param {Object} options - Options for GetMediaURL (quality, etc.)
// //  * @returns {string|null} - Display URL or null
// //  */
// // export const getTenantMediaDisplayURL = (mediaItem, options = { quality: 80 }) => {
// //   if (!mediaItem?.location) return null;
// //   return GetMediaURL(paths.media.download, mediaItem.location, options);
// // };

// // /**
// //  * Get profile image URL for tenant
// //  * @param {Object} tenant - Tenant object
// //  * @param {Object} options - Options for GetMediaURL
// //  * @returns {string|null} - Profile image URL or null
// //  */
// // export const getTenantProfileImageURL = (tenant, options = { quality: 80 }) => {
// //   // Check for existing media in database
// //   if (tenant.media?.profile_picture?.location) {
// //     return getTenantMediaDisplayURL(tenant.media.profile_picture, options);
// //   }

// //   // Check for file object (newly uploaded)
// //   if (tenant.profile_picture) {
// //     return typeof tenant.profile_picture === "string"
// //       ? tenant.profile_picture
// //       : URL.createObjectURL(tenant.profile_picture);
// //   }

// //   return null;
// // };

// // /**
// //  * Get document URL for tenant
// //  * @param {Object} tenant - Tenant object
// //  * @param {string} documentType - Type of document (aadhar_front, aadhar_back, pan, etc.)
// //  * @param {Object} options - Options for GetMediaURL
// //  * @returns {string|null} - Document URL or null
// //  */
// // export const getTenantDocumentURL = (tenant, documentType, options = { quality: 80 }) => {
// //   // Check for existing media in database
// //   if (tenant.media?.[documentType]?.location) {
// //     return getTenantMediaDisplayURL(tenant.media[documentType], options);
// //   }

// //   // Check for file object (newly uploaded)
// //   if (tenant[documentType]) {
// //     return typeof tenant[documentType] === "string"
// //       ? tenant[documentType]
// //       : URL.createObjectURL(tenant[documentType]);
// //   }

// //   return null;
// // };

// // /**
// //  * Validate tenant file before processing
// //  * @param {File} file - File to validate
// //  * @param {string} fileType - Type of file for specific validation
// //  * @returns {Object} - Validation result
// //  */
// // export const validateTenantFile = (file, fileType) => {
// //   const errors = [];

// //   if (!file) {
// //     errors.push("No file selected");
// //     return { isValid: false, errors };
// //   }

// //   // Check file type
// //   if (!file.type.startsWith("image/")) {
// //     errors.push("Only image files (PNG, JPG, JPEG) are allowed");
// //   }

// //   // Check file size (max 5MB, 2MB for profile)
// //   const maxSize = fileType === "profile_picture" ? 2 * 1024 * 1024 : 5 * 1024 * 1024;
// //   if (file.size > maxSize) {
// //     const maxSizeMB = fileType === "profile_picture" ? "2MB" : "5MB";
// //     errors.push(`File size should be less than ${maxSizeMB}`);
// //   }

// //   return {
// //     isValid: errors.length === 0,
// //     errors,
// //   };
// // };

// // /**
// //  * Get document display name
// //  * @param {string} documentType - Document type key
// //  * @returns {string} - Human readable name
// //  */
// // export const getDocumentDisplayName = (documentType) => {
// //   const displayNames = {
// //     profile_picture: "Profile Picture",
// //     aadhar_front: "Aadhar Card (Front)",
// //     aadhar_back: "Aadhar Card (Back)",
// //     pan: "PAN Card",
// //     rent_agreement: "Rent Agreement",
// //   };

// //   return displayNames[documentType] || documentType;
// // };

// // /**
// //  * Format file size for display
// //  * @param {number} bytes - File size in bytes
// //  * @returns {string} - Formatted file size
// //  */
// // export const formatFileSize = (bytes) => {
// //   if (bytes === 0) return "0 Bytes";

// //   const k = 1024;
// //   const sizes = ["Bytes", "KB", "MB", "GB"];
// //   const i = Math.floor(Math.log(bytes) / Math.log(k));

// //   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
// // };

// // /**
// //  * Check if tenant has any uploaded documents
// //  * @param {Object} tenant - Tenant object
// //  * @returns {boolean} - True if has documents
// //  */
// // export const tenantHasDocuments = (tenant) => {
// //   const documentTypes = [
// //     "profile_picture",
// //     "aadhar_front",
// //     "aadhar_back",
// //     "pan",
// //     "rent_agreement",
// //   ];

// //   return documentTypes.some((type) => {
// //     return tenant.media?.[type]?.location || tenant[type];
// //   });
// // };

// // /**
// //  * Get tenant document status summary
// //  * @param {Object} tenant - Tenant object
// //  * @returns {Object} - Document status summary
// //  */
// // export const getTenantDocumentStatus = (tenant) => {
// //   const documents = {
// //     profile_picture: getTenantDocumentURL(tenant, "profile_picture") !== null,
// //     aadhar_front: getTenantDocumentURL(tenant, "aadhar_front") !== null,
// //     aadhar_back: getTenantDocumentURL(tenant, "aadhar_back") !== null,
// //     pan: getTenantDocumentURL(tenant, "pan") !== null,
// //     rent_agreement: getTenantDocumentURL(tenant, "rent_agreement") !== null,
// //   };

// //   const totalDocuments = Object.keys(documents).length;
// //   const uploadedDocuments = Object.values(documents).filter(Boolean).length;

// //   return {
// //     documents,
// //     totalDocuments,
// //     uploadedDocuments,
// //     completionPercentage: Math.round((uploadedDocuments / totalDocuments) * 100),
// //     isComplete: uploadedDocuments === totalDocuments,
// //   };
// // };

// // /**
// //  * Create media object for Firebase upload
// //  * @param {File} file - File object
// //  * @param {string} firebasePath - Firebase storage path
// //  * @param {string} downloadURL - Download URL from Firebase
// //  * @returns {Object} - Media object
// //  */
// // export const createFirebaseMediaObject = (file, firebasePath, downloadURL) => {
// //   return {
// //     name: file.name,
// //     location: firebasePath,
// //     url: downloadURL,
// //     type: file.type,
// //     size: file.size,
// //     description: "",
// //     originalPath: file.name,
// //   };
// // };

// // /**
// //  * Get upload base path for tenant documents
// //  * @param {string} documentType - Type of document
// //  * @param {Object} user - User object
// //  * @returns {string} - Upload base path
// //  */
// // export const getTenantUploadBasePath = (documentType, user) => {
// //   const pathMapping = {
// //     profile: "tenants/profile",
// //     aadharFront: "tenants/aadhar",
// //     aadharBack: "tenants/aadhar",
// //     pan: "tenants/pan",
// //     rent: "tenants/agreement",
// //   };

// //   const basePath = pathMapping[documentType] || "tenants/documents";
// //   return GetUploadMediaBaseLocation(basePath, user);
// // };

// // /**
// //  * Process tenant media for API submission
// //  * @param {Object} tenant - Tenant object with files and existing media
// //  * @param {Array} uploadedFiles - Files uploaded to Firebase
// //  * @returns {Object} - Processed media object for API
// //  */
// // export const processTenantMediaForAPI = (tenant, uploadedFiles = {}) => {
// //   const media = { ...(tenant.media || {}) };

// //   // Update with newly uploaded files
// //   Object.keys(uploadedFiles).forEach(key => {
// //     if (uploadedFiles[key]) {
// //       media[key] = uploadedFiles[key];
// //     }
// //   });

// //   return media;
// // };

// // /**
// //  * Get tenant initials for display
// //  * @param {string} firstName - First name
// //  * @param {string} lastName - Last name
// //  * @returns {string} - Initials
// //  */
// // export const getTenantInitials = (firstName, lastName) => {
// //   const first = firstName ? firstName.charAt(0).toUpperCase() : "";
// //   const last = lastName ? lastName.charAt(0).toUpperCase() : "";
// //   return `${first}${last}`;
// // };

// // /**
// //  * Validate tenant form data
// //  * @param {Object} tenantData - Tenant form data
// //  * @returns {Object} - Validation result
// //  */
// // export const validateTenantFormData = (tenantData) => {
// //   const errors = [];

// //   if (!tenantData.mobile || tenantData.mobile.length !== 10) {
// //     errors.push("Mobile number must be 10 digits");
// //   }

// //   if (!tenantData.first_name || tenantData.first_name.trim().length < 2) {
// //     errors.push("First name must be at least 2 characters");
// //   }

// //   if (!tenantData.last_name || tenantData.last_name.trim().length < 2) {
// //     errors.push("Last name must be at least 2 characters");
// //   }

// //   return {
// //     isValid: errors.length === 0,
// //     errors,
// //   };
// // };

// // utils/tenantMediaUtils.js
// import { GetMediaURL, GetUploadMediaBaseLocation } from "../Utility/APICall";
// import { paths } from "../Utility/Constants";

// /**
//  * Get display URL for tenant media using your GetMediaURL function
//  * @param {Object} mediaItem - Media item with location
//  * @param {Object} options - Options for GetMediaURL (quality, etc.)
//  * @returns {string|null} - Display URL or null
//  */
// export const getTenantMediaDisplayURL = (
//   mediaItem,
//   options = { quality: 80 }
// ) => {
//   if (!mediaItem?.location) return null;
//   return GetMediaURL(paths.media.download, mediaItem.location, options);
// };

// /**
//  * Get profile image URL for tenant
//  * @param {Object} tenant - Tenant object
//  * @param {Object} options - Options for GetMediaURL
//  * @returns {string|null} - Profile image URL or null
//  */
// export const getTenantProfileImageURL = (tenant, options = { quality: 80 }) => {
//   // Check for existing media in database
//   if (tenant.media?.profile_picture?.location) {
//     return getTenantMediaDisplayURL(tenant.media.profile_picture, options);
//   }

//   // Check for file object (newly uploaded)
//   if (tenant.profile_picture) {
//     return typeof tenant.profile_picture === "string"
//       ? tenant.profile_picture
//       : URL.createObjectURL(tenant.profile_picture);
//   }

//   return null;
// };

// /**
//  * Get document URL for tenant
//  * @param {Object} tenant - Tenant object
//  * @param {string} documentType - Type of document (aadhar_front, aadhar_back, pan, etc.)
//  * @param {Object} options - Options for GetMediaURL
//  * @returns {string|null} - Document URL or null
//  */
// export const getTenantDocumentURL = (
//   tenant,
//   documentType,
//   options = { quality: 80 }
// ) => {
//   if (!tenant || !documentType) return null;

//   if (tenant.media?.[documentType]?.location) {
//     return GetMediaURL(
//       paths.media.download,
//       tenant.media[documentType].location,
//       options
//     );
//   }

//   const docData = tenant[documentType];
//   if (docData) {
//     if (
//       typeof docData === "object" &&
//       docData.location &&
//       !(docData instanceof File)
//     ) {
//       return GetMediaURL(paths.media.download, docData.location, options);
//     }
//     if (docData instanceof File) {
//       return URL.createObjectURL(docData);
//     }
//     if (typeof docData === "string") {
//       return docData;
//     }
//   }

//   return null;
// };

// /**
//  * Validate tenant file before processing
//  * @param {File} file - File to validate
//  * @param {string} fileType - Type of file for specific validation
//  * @returns {Object} - Validation result
//  */
// export const validateTenantFile = (file, fileType) => {
//   const errors = [];

//   if (!file) {
//     errors.push("No file selected");
//     return { isValid: false, errors };
//   }

//   // Check file type
//   if (!file.type.startsWith("image/")) {
//     errors.push("Only image files (PNG, JPG, JPEG) are allowed");
//   }

//   // Check file size (max 5MB, 2MB for profile)
//   const maxSize =
//     fileType === "profile_picture" ? 2 * 1024 * 1024 : 5 * 1024 * 1024;
//   if (file.size > maxSize) {
//     const maxSizeMB = fileType === "profile_picture" ? "2MB" : "5MB";
//     errors.push(`File size should be less than ${maxSizeMB}`);
//   }

//   return {
//     isValid: errors.length === 0,
//     errors,
//   };
// };

// /**
//  * Get document display name
//  * @param {string} documentType - Document type key
//  * @returns {string} - Human readable name
//  */
// export const getDocumentDisplayName = (documentType) => {
//   const displayNames = {
//     profile_picture: "Profile Picture",
//     aadhar_front: "Aadhar Card (Front)",
//     aadhar_back: "Aadhar Card (Back)",
//     pan: "PAN Card",
//     rent_agreement: "Rent Agreement",
//   };

//   return displayNames[documentType] || documentType;
// };

// /**
//  * Format file size for display
//  * @param {number} bytes - File size in bytes
//  * @returns {string} - Formatted file size
//  */
// export const formatFileSize = (bytes) => {
//   if (bytes === 0) return "0 Bytes";

//   const k = 1024;
//   const sizes = ["Bytes", "KB", "MB", "GB"];
//   const i = Math.floor(Math.log(bytes) / Math.log(k));

//   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
// };

// /**
//  * Check if tenant has any uploaded documents
//  * @param {Object} tenant - Tenant object
//  * @returns {boolean} - True if has documents
//  */
// export const tenantHasDocuments = (tenant) => {
//   const documentTypes = [
//     "profile_picture",
//     "aadhar_front",
//     "aadhar_back",
//     "pan",
//     "rent_agreement",
//   ];

//   return documentTypes.some((type) => {
//     return tenant.media?.[type]?.location || tenant[type];
//   });
// };

// /**
//  * Get tenant document status summary
//  * @param {Object} tenant - Tenant object
//  * @returns {Object} - Document status summary
//  */
// export const getTenantDocumentStatus = (tenant) => {
//   const documents = {
//     profile_picture: getTenantDocumentURL(tenant, "profile_picture") !== null,
//     aadhar_front: getTenantDocumentURL(tenant, "aadhar_front") !== null,
//     aadhar_back: getTenantDocumentURL(tenant, "aadhar_back") !== null,
//     pan: getTenantDocumentURL(tenant, "pan") !== null,
//     rent_agreement: getTenantDocumentURL(tenant, "rent_agreement") !== null,
//   };

//   const totalDocuments = Object.keys(documents).length;
//   const uploadedDocuments = Object.values(documents).filter(Boolean).length;

//   return {
//     documents,
//     totalDocuments,
//     uploadedDocuments,
//     completionPercentage: Math.round(
//       (uploadedDocuments / totalDocuments) * 100
//     ),
//     isComplete: uploadedDocuments === totalDocuments,
//   };
// };

// /**
//  * Create media object for Firebase upload
//  * @param {File} file - File object
//  * @param {string} firebasePath - Firebase storage path
//  * @param {string} downloadURL - Download URL from Firebase
//  * @returns {Object} - Media object
//  */
// export const createFirebaseMediaObject = (file, firebasePath, downloadURL) => {
//   return {
//     name: file.name,
//     location: firebasePath,
//     url: downloadURL,
//     type: file.type,
//     size: file.size,
//     description: "",
//     originalPath: file.name,
//   };
// };

// /**
//  * Get upload base path for tenant documents
//  * @param {string} documentType - Type of document
//  * @param {Object} user - User object
//  * @returns {string} - Upload base path
//  */
// export const getTenantUploadBasePath = (documentType, user) => {
//   const pathMapping = {
//     profile: "tenants/profile",
//     aadharFront: "tenants/aadhar",
//     aadharBack: "tenants/aadhar",
//     pan: "tenants/pan",
//     rent: "tenants/agreement",
//   };

//   const basePath = pathMapping[documentType] || "tenants/documents";
//   return GetUploadMediaBaseLocation(basePath, user);
// };

// /**
//  * Process tenant media for API submission
//  * @param {Object} tenant - Tenant object with files and existing media
//  * @param {Array} uploadedFiles - Files uploaded to Firebase
//  * @returns {Object} - Processed media object for API
//  */
// export const processTenantMediaForAPI = (tenant, uploadedFiles = {}) => {
//   const media = { ...(tenant.media || {}) };

//   // Update with newly uploaded files
//   Object.keys(uploadedFiles).forEach((key) => {
//     if (uploadedFiles[key]) {
//       media[key] = uploadedFiles[key];
//     }
//   });

//   return media;
// };

// /**
//  * Get tenant initials for display
//  * @param {string} firstName - First name
//  * @param {string} lastName - Last name
//  * @returns {string} - Initials
//  */
// export const getTenantInitials = (firstName, lastName) => {
//   const first = firstName ? firstName.charAt(0).toUpperCase() : "";
//   const last = lastName ? lastName.charAt(0).toUpperCase() : "";
//   return `${first}${last}`;
// };

// /**
//  * Validate tenant form data
//  * @param {Object} tenantData - Tenant form data
//  * @returns {Object} - Validation result
//  */
// export const validateTenantFormData = (tenantData) => {
//   const errors = [];

//   if (!tenantData.mobile || tenantData.mobile.length !== 10) {
//     errors.push("Mobile number must be 10 digits");
//   }

//   if (!tenantData.first_name || tenantData.first_name.trim().length < 2) {
//     errors.push("First name must be at least 2 characters");
//   }

//   if (!tenantData.last_name || tenantData.last_name.trim().length < 2) {
//     errors.push("Last name must be at least 2 characters");
//   }

//   return {
//     isValid: errors.length === 0,
//     errors,
//   };
// };

// utils/tenantFileUtils.js
import { GetMediaURL, GetUploadMediaBaseLocation } from "../Utility/APICall";
import { paths } from "../Utility/Constants";

/**
 * Get display URL for tenant media using your GetMediaURL function
 * @param {Object} mediaItem - Media item with location
 * @param {Object} options - Options for GetMediaURL (quality, etc.)
 * @returns {string|null} - Display URL or null
 */
export const getTenantMediaDisplayURL = (
  mediaItem,
  options = { quality: 80 }
) => {
  if (!mediaItem?.location) return null;
  return GetMediaURL(paths.media.download, mediaItem.location, options);
};

/**
 * Get profile image URL for tenant with enhanced debugging
 * @param {Object} tenant - Tenant object
 * @param {Object} options - Options for GetMediaURL
 * @returns {string|null} - Profile image URL or null
 */
export const getTenantProfileImageURL = (tenant, options = { quality: 80 }) => {
  console.log("🔍 getTenantProfileImageURL called with:", { tenant, options });

  if (!tenant) {
    console.warn("❌ No tenant provided");
    return null;
  }

  // Check for existing media in database (most common case)
  if (tenant.media?.profile_picture?.location) {
    const url = GetMediaURL(
      paths.media.download,
      tenant.media.profile_picture.location,
      options
    );
    console.log("✅ Generated URL from tenant.media.profile_picture:", url);
    return url;
  }

  // Check direct property
  if (tenant.profile_picture?.location) {
    const url = GetMediaURL(
      paths.media.download,
      tenant.profile_picture.location,
      options
    );
    console.log("✅ Generated URL from tenant.profile_picture:", url);
    return url;
  }

  // Check for file object (newly uploaded)
  if (tenant.profile_picture) {
    if (tenant.profile_picture instanceof File) {
      const blobUrl = URL.createObjectURL(tenant.profile_picture);
      console.log("✅ Created blob URL for File object:", blobUrl);
      return blobUrl;
    }
    if (typeof tenant.profile_picture === "string") {
      console.log("✅ Using string URL:", tenant.profile_picture);
      return tenant.profile_picture;
    }
  }

  console.log("❌ No profile image found for tenant");
  return null;
};

/**
 * Get document URL for tenant with enhanced debugging and error handling
 * @param {Object} tenant - Tenant object
 * @param {string} documentType - Type of document (aadhar_front, aadhar_back, pan, etc.)
 * @param {Object} options - Options for GetMediaURL
 * @returns {string|null} - Document URL or null
 */
export const getTenantDocumentURL = (
  tenant,
  documentType,
  options = { quality: 80 }
) => {
  console.log(`🔍 getTenantDocumentURL called for ${documentType}:`, {
    tenant,
    documentType,
    options,
  });

  if (!tenant || !documentType) {
    console.warn("❌ Missing tenant or documentType:", {
      tenant: !!tenant,
      documentType,
    });
    return null;
  }

  // Method 1: Check tenant.media[documentType].location (most common for DB data)
  if (tenant.media?.[documentType]?.location) {
    const location = tenant.media[documentType].location;
    const url = GetMediaURL(paths.media.download, location, options);
    console.log(`✅ Generated URL from tenant.media.${documentType}:`, {
      location,
      url,
    });
    return url;
  }

  // Method 2: Check direct property tenant[documentType].location
  const docData = tenant[documentType];
  if (docData) {
    console.log(`🔍 Found docData for ${documentType}:`, docData);

    // If it's an object with location property (but not a File)
    if (
      typeof docData === "object" &&
      docData.location &&
      !(docData instanceof File)
    ) {
      const url = GetMediaURL(paths.media.download, docData.location, options);
      console.log(`✅ Generated URL from tenant.${documentType}.location:`, {
        location: docData.location,
        url,
      });
      return url;
    }

    // If it's a File object (newly selected)
    if (docData instanceof File) {
      const blobUrl = URL.createObjectURL(docData);
      console.log(`✅ Created blob URL for File object:`, blobUrl);
      return blobUrl;
    }

    // If it's a string URL
    if (typeof docData === "string") {
      console.log(`✅ Using string URL:`, docData);
      return docData;
    }
  }

  console.log(`❌ No document found for ${documentType}`);
  return null;
};

/**
 * Enhanced version with authentication support
 * Get document URL for tenant with JWT authentication
 * @param {Object} tenant - Tenant object
 * @param {string} documentType - Type of document
 * @param {string} jwt - JWT token for authentication
 * @param {Object} options - Options for GetMediaURL
 * @returns {string|null} - Document URL or null
 */
export const getTenantDocumentURLWithAuth = (
  tenant,
  documentType,
  jwt,
  options = { quality: 80 }
) => {
  const baseUrl = getTenantDocumentURL(tenant, documentType, options);

  if (!baseUrl) return null;

  // If it's a blob URL or external URL, return as-is
  if (
    baseUrl.startsWith("blob:") ||
    baseUrl.startsWith("http://") ||
    baseUrl.startsWith("https://")
  ) {
    return baseUrl;
  }

  // For API URLs, you might need to add authentication
  // This depends on how your GetMediaURL function handles authentication
  console.log("🔐 Generated authenticated URL:", baseUrl);
  return baseUrl;
};

/**
 * Test if an image URL is loadable
 * @param {string} url - Image URL to test
 * @param {string} jwt - JWT token for authentication
 * @returns {Promise<boolean>} - Promise that resolves to true if image loads
 */
export const testImageLoadability = (url, jwt = null) => {
  return new Promise((resolve) => {
    if (!url) {
      console.log("❌ No URL to test");
      resolve(false);
      return;
    }

    console.log("🧪 Testing image loadability:", url);

    const img = new Image();

    // Set up authentication if needed
    if (jwt && url.includes("/api/")) {
      img.crossOrigin = "use-credentials";
      // Note: You might need to handle authentication differently
      // depending on your API setup
    }

    img.onload = () => {
      console.log("✅ Image loaded successfully:", url);
      resolve(true);
    };

    img.onerror = (error) => {
      console.error("❌ Image failed to load:", url, error);
      resolve(false);
    };

    // Add timeout
    setTimeout(() => {
      console.warn("⏰ Image load timeout:", url);
      resolve(false);
    }, 10000); // 10 second timeout

    img.src = url;
  });
};

/**
 * Get document URL with validation
 * @param {Object} tenant - Tenant object
 * @param {string} documentType - Document type
 * @param {string} jwt - JWT token
 * @param {Object} options - Options
 * @returns {Promise<string|null>} - Validated URL or null
 */
export const getValidatedTenantDocumentURL = async (
  tenant,
  documentType,
  jwt = null,
  options = { quality: 80 }
) => {
  const url = getTenantDocumentURL(tenant, documentType, options);

  if (!url) {
    console.log(`❌ No URL generated for ${documentType}`);
    return null;
  }

  const isLoadable = await testImageLoadability(url, jwt);

  if (!isLoadable) {
    console.error(`❌ Generated URL is not loadable: ${url}`);
    return null;
  }

  return url;
};

/**
 * Debug tenant data structure
 * @param {Object} tenant - Tenant object
 * @param {string} context - Context for debugging
 */
export const debugTenantData = (tenant, context = "unknown") => {
  console.log(`=== 🐛 DEBUG TENANT DATA (${context}) ===`);
  console.log("📋 Full tenant object:", tenant);
  console.log("📁 Tenant media object:", tenant?.media);
  console.log("📄 Direct document properties:", {
    profile_picture: tenant?.profile_picture,
    aadhar_front: tenant?.aadhar_front,
    aadhar_back: tenant?.aadhar_back,
    pan: tenant?.pan,
    rent_agreement: tenant?.rent_agreement,
  });

  if (tenant?.media) {
    console.log("📋 Media locations:", {
      profile_picture: tenant.media.profile_picture?.location,
      aadhar_front: tenant.media.aadhar_front?.location,
      aadhar_back: tenant.media.aadhar_back?.location,
      pan: tenant.media.pan?.location,
      rent_agreement: tenant.media.rent_agreement?.location,
    });
  }

  console.log("=======================================");
};

/**
 * Get all document URLs for a tenant
 * @param {Object} tenant - Tenant object
 * @param {Object} options - Options for GetMediaURL
 * @returns {Object} - Object with all document URLs
 */
export const getAllTenantDocumentURLs = (tenant, options = { quality: 80 }) => {
  const documentTypes = [
    "profile_picture",
    "aadhar_front",
    "aadhar_back",
    "pan",
    "rent_agreement",
  ];
  const urls = {};

  documentTypes.forEach((docType) => {
    urls[docType] = getTenantDocumentURL(tenant, docType, options);
  });

  console.log("📄 All document URLs:", urls);
  return urls;
};

// Rest of your existing functions remain the same...

/**
 * Validate tenant file before processing
 * @param {File} file - File to validate
 * @param {string} fileType - Type of file for specific validation
 * @returns {Object} - Validation result
 */
export const validateTenantFile = (file, fileType) => {
  const errors = [];

  if (!file) {
    errors.push("No file selected");
    return { isValid: false, errors };
  }

  // Check file type
  if (!file.type.startsWith("image/")) {
    errors.push("Only image files (PNG, JPG, JPEG) are allowed");
  }

  // Check file size (max 5MB, 2MB for profile)
  const maxSize =
    fileType === "profile_picture" ? 2 * 1024 * 1024 : 5 * 1024 * 1024;
  if (file.size > maxSize) {
    const maxSizeMB = fileType === "profile_picture" ? "2MB" : "5MB";
    errors.push(`File size should be less than ${maxSizeMB}`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

/**
 * Get document display name
 * @param {string} documentType - Document type key
 * @returns {string} - Human readable name
 */
export const getDocumentDisplayName = (documentType) => {
  const displayNames = {
    profile_picture: "Profile Picture",
    aadhar_front: "Aadhar Card (Front)",
    aadhar_back: "Aadhar Card (Back)",
    pan: "PAN Card",
    rent_agreement: "Rent Agreement",
  };

  return displayNames[documentType] || documentType;
};

/**
 * Format file size for display
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Check if tenant has any uploaded documents
 * @param {Object} tenant - Tenant object
 * @returns {boolean} - True if has documents
 */
export const tenantHasDocuments = (tenant) => {
  const documentTypes = [
    "profile_picture",
    "aadhar_front",
    "aadhar_back",
    "pan",
    "rent_agreement",
  ];

  return documentTypes.some((type) => {
    return tenant.media?.[type]?.location || tenant[type];
  });
};

/**
 * Get tenant document status summary
 * @param {Object} tenant - Tenant object
 * @returns {Object} - Document status summary
 */
export const getTenantDocumentStatus = (tenant) => {
  const documents = {
    profile_picture: getTenantDocumentURL(tenant, "profile_picture") !== null,
    aadhar_front: getTenantDocumentURL(tenant, "aadhar_front") !== null,
    aadhar_back: getTenantDocumentURL(tenant, "aadhar_back") !== null,
    pan: getTenantDocumentURL(tenant, "pan") !== null,
    rent_agreement: getTenantDocumentURL(tenant, "rent_agreement") !== null,
  };

  const totalDocuments = Object.keys(documents).length;
  const uploadedDocuments = Object.values(documents).filter(Boolean).length;

  return {
    documents,
    totalDocuments,
    uploadedDocuments,
    completionPercentage: Math.round(
      (uploadedDocuments / totalDocuments) * 100
    ),
    isComplete: uploadedDocuments === totalDocuments,
  };
};

/**
 * Create media object for Firebase upload
 * @param {File} file - File object
 * @param {string} firebasePath - Firebase storage path
 * @param {string} downloadURL - Download URL from Firebase
 * @returns {Object} - Media object
 */
export const createFirebaseMediaObject = (file, firebasePath, downloadURL) => {
  return {
    name: file.name,
    location: firebasePath,
    url: downloadURL,
    type: file.type,
    size: file.size,
    description: "",
    originalPath: file.name,
  };
};

/**
 * Get upload base path for tenant documents
 * @param {string} documentType - Type of document
 * @param {Object} user - User object
 * @returns {string} - Upload base path
 */
export const getTenantUploadBasePath = (documentType, user) => {
  const pathMapping = {
    profile: "tenants/profile",
    aadharFront: "tenants/aadhar",
    aadharBack: "tenants/aadhar",
    pan: "tenants/pan",
    rent: "tenants/agreement",
  };

  const basePath = pathMapping[documentType] || "tenants/documents";
  return GetUploadMediaBaseLocation(basePath, user);
};

/**
 * Process tenant media for API submission
 * @param {Object} tenant - Tenant object with files and existing media
 * @param {Array} uploadedFiles - Files uploaded to Firebase
 * @returns {Object} - Processed media object for API
 */
export const processTenantMediaForAPI = (tenant, uploadedFiles = {}) => {
  const media = { ...(tenant.media || {}) };

  // Update with newly uploaded files
  Object.keys(uploadedFiles).forEach((key) => {
    if (uploadedFiles[key]) {
      media[key] = uploadedFiles[key];
    }
  });

  return media;
};

/**
 * Get tenant initials for display
 * @param {string} firstName - First name
 * @param {string} lastName - Last name
 * @returns {string} - Initials
 */
export const getTenantInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : "";
  const last = lastName ? lastName.charAt(0).toUpperCase() : "";
  return `${first}${last}`;
};

/**
 * Validate tenant form data
 * @param {Object} tenantData - Tenant form data
 * @returns {Object} - Validation result
 */
export const validateTenantFormData = (tenantData) => {
  const errors = [];

  if (!tenantData.mobile || tenantData.mobile.length !== 10) {
    errors.push("Mobile number must be 10 digits");
  }

  if (!tenantData.first_name || tenantData.first_name.trim().length < 2) {
    errors.push("First name must be at least 2 characters");
  }

  if (!tenantData.last_name || tenantData.last_name.trim().length < 2) {
    errors.push("Last name must be at least 2 characters");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};
